<div class="grid header-bg">
	<div class="header-content grid-center">
		<h1 id="title" class="sdds-expressive-headline-02">{{ 'eys.title' | translate }}</h1>
	</div>
</div>